import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterRecargaCreditoView.
 * @extends JetView
 */
export default class FilterRecargaCreditoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with input for account ID
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'cuenta_id', // Input name for account ID
                    label: _('ID Nota de Retiro:'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('ID Nota de Retiro:'), // Placeholder text
                },
            ],
        };

        // Center left section with input for observations
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'observ', // Input name for observations
                    label: _('Observaciones:'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Observaciones:'), // Placeholder text
                },
            ],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the left and center left components
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Data object for payment information
        const datos = {
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        // Button section with Clear and Consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                        $$('formRecargaCredito').hide(); // Hides the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Retrieves form values
                        if (filterdata.Id !== '' || filterdata.Cedula !== '' || filterdata.Email !== '') {
                            // Checks if at least one filter is provided
                            webix.ajax().get(
                                devConfig.geturlApi() + '/GetNoteWithgraw', // API endpoint
                                'cuenta_id=' + filterdata.cuenta_id + '&observ=' + filterdata.observ,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        text = JSON.parse(text); // Parses the response
                                        test.app.callEvent(
                                            'eliminateNoteWithdraw:data',
                                            [text[0]], // Calls event with the first item of the response
                                        );
                                    },
                                },
                            );
                            $$('formEliminateNoteWithdraw').show(); // Shows the form for eliminating notes
                            $$('filterTableEliminateNoteWithdraw').show(); // Shows the filter table
                            $$('tableEliminateNoteWithdraw').show(); // Shows the table for eliminated notes
                        } else {
                            webix.message({
                                text: _('Filtre Mínimo por un campo'), // Error message for minimum filter
                                type: 'error',
                                expire: 1000,
                            });
                        }
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                Email: webix.rules.isEmail, // Validation rule for email
            },
        };
    }
}

// FILE DOCUMENTED
